import styled from "styled-components";


export const CardItemTitle = styled.p`
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    color: #212529;
`

export const CardItemSpan = styled.span`
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    color: #212529;
`